export function progressiveCourseAttachmentStreamUrl(absoluteUrl) {
  const raw = String(absoluteUrl || '').trim();
  if (!raw) return raw;
  try {
    const u = new URL(raw);
    const next = u.pathname.replace(/(\/attachments\/[a-fA-F0-9]{24})\/?$/, '$1/stream');
    if (next !== u.pathname) {
      u.pathname = next;
      return u.toString();
    }
  } catch (_) {
    /* ignore */
  }
  return raw;
}

/**
 * Lesson attachments are either a Mongo id string or a populated { _id, filename } from the API.
 */
export function attachmentId(value) {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value === 'object') {
    const id = value._id ?? value.id;
    return id != null && id !== '' ? String(id) : '';
  }
  return String(value);
}
